<template>
  <div id="app">
    <img class="logo" src="./assets/logo.jpg">
    <img class="title" src="./assets/title.png">
    <!--<transition name="silkRibbon">-->
      <!--<img v-show="silkRibbonShow" class="bg" src="./assets/bg.png">-->
    <!--</transition>-->
    <canvas v-show="false" id="canvas"></canvas>
    <!-- <div v-show="false" id="canvas"></div> -->
    <img :src="codeSrc" class="code">
    <img class="text" src="./assets/tip.png" />
  </div>
</template>

<script>
import QRCode from 'qrcode'
export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      QueryDetail: '',
      codeSrc: '',
      devicePixelRatio: 1,
      silkRibbonShow: false,
      productShow: false
    }
  },
  methods: {
    showNoPre () {
      // 生成的二维码内容，可以添加变量
　　　this.QueryDetail = 'http://p.ijovo.com/e/' + this.GetQueryString('wxextinfo') + '///flag'
      let canvas = document.getElementById('canvas')
      QRCode.toCanvas(canvas, this.QueryDetail, (error) => {
        if (error) console.error(error)
        console.log('success!');
        this.codeSrc = canvas.toDataURL("image/png")
      })
    },
    GetQueryString (name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let search = window.location.href.split('?')[1] || ''
      let r = search.match(reg)
      if (r !== null) {
        return unescape(r[2])
      }
      return null
    }
  },
  created () {
    this.$nextTick(() => {
      this.silkRibbonShow = true
      this.productShow = true
      this.devicePixelRatio = window.devicePixelRatio
      // this.$refs.text.style.fontSize = (20 / 2) * this.devicePixelRatio + 'px'
      // this.$refs.text.style.lineHeight = (26 / 2) * this.devicePixelRatio + 'px'
      this.showNoPre()
    })
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  background-image: url("./assets/bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: hidden;
}
.product{
  position:absolute;
  width: 450px;
  top: 72%;
  left: 50%;
  margin-left: -225px;
}
.logo{
  position: absolute;
  left: 41px;
  top: 41px;
}
.bg{
  position: absolute;
  top: 8%;
}
.title{
  position: absolute;
  left: 50%;
  top: 17.8%;
  margin-left: -268px;
}
#canvas,.code{
  width: 290px!important;
  height: 290px!important;
  position: absolute;
  z-index: 2;
  left: 227px;
  top: 52.4%;
  padding: 6px;
  border-radius: 4px;
  background: #b4d6ec;
  box-sizing: border-box;
}
.text{
  font-size: 20px;
  color: #fff;
  position: absolute;
  top: 80%;
  left: 50%;
  margin-left: -166.5px;
  /*line-height: 30px;*/
  text-align: center;
}
.silkRibbon-enter-active {
  transition: all 1.4s ease;
}
.silkRibbon-enter, .silkRibbon-leave-to{
  opacity: 0;
  transform: translateY(-160px);
}
.product-enter-active {
  transition: all .4s ease;
}
.product-enter, .product-leave-to{
  opacity: 0;
  transform: translateX(300px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue